import PriceWithrawlAddPage from './PriceWithrawlAddPage';

export default PriceWithrawlAddPage;
